// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-questionnaire-wrapper {
  border-top: 1px #e0e0e0 solid;
}
.registration-questionnaire-wrapper p {
  padding-top: 3rem;
}
.registration-questionnaire-wrapper .registration-questionnaire-button-container {
  margin-top: 5rem;
  display: flex;
  justify-content: space-between;
}
.registration-questionnaire-wrapper .registration-questionnaire-button-container .back-button,
.registration-questionnaire-wrapper .registration-questionnaire-button-container .submit-button {
  width: 15rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderRegistrationLayout/RegistrationQuestionnaire/index.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AAFJ;AAII;;EAEE,YAAA;AAFN","sourcesContent":["@use '@Styles/variables';\n\n.registration-questionnaire-wrapper {\n  border-top: 1px variables.$grayColor5 solid;\n\n  p {\n    padding-top: 3rem;\n  }\n\n  .registration-questionnaire-button-container {\n    margin-top: 5rem;\n    display: flex;\n    justify-content: space-between;\n\n    .back-button,\n    .submit-button {\n      width: 15rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
